module.exports = __webpack_public_path__ + "img/11088028_L.d2db04fe.png";